module.exports = __webpack_public_path__ + "static/media/3.6d1cd686.png";